"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _ButtonGroup = _interopRequireDefault(require("@icare/components/lib/ButtonGroup"));

var _GenericForm = _interopRequireDefault(require("./GenericForm"));

var _LayoutField = _interopRequireDefault(require("./LayoutField"));

var _FormErrorSummary = _interopRequireDefault(require("./FormErrorSummary"));

var _adapters = _interopRequireDefault(require("../adapters"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBuilder, _React$Component);

  var _super = _createSuper(FormBuilder);

  function FormBuilder(props) {
    var _this;

    _classCallCheck(this, FormBuilder);

    _this = _super.call(this, props);
    _this._adapters = _adapters.default; // Merge custom adaptors with default ones

    if (props.adapters) {
      _this._adapters = Object.assign({}, _adapters.default, props.adapters);
    }

    return _this;
  }

  _createClass(FormBuilder, [{
    key: "renderSection",
    value: function renderSection(section) {
      var _this2 = this;

      var formStore = this.props.formStore; // Render nothing for empty sections.

      if (!section.fields || !section.fields.length || section.id === 'meta') {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("fieldset", {
        className: "fieldset"
      }, section.title && /*#__PURE__*/_react.default.createElement("legend", null, section.title), (section.description || section.text) && /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: section.description || section.text
        }
      }), section.fields.map(function (field) {
        return /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
          key: "".concat(section.id, "__").concat(field.id),
          fieldId: field.id,
          sectionId: section.id,
          form: formStore,
          adapters: _this2._adapters
        });
      }), section.afterText && /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: section.afterText
        }
      }));
    }
  }, {
    key: "renderFields",
    value: function renderFields() {
      var _this3 = this;

      var formStore = this.props.formStore;

      if (!formStore.sections) {
        return formStore.map(function (field) {
          return /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
            key: field.id,
            sectionId: "form",
            fieldId: field.id,
            form: formStore,
            adapters: _this3._adapters
          });
        });
      }

      return formStore.sections.map(function (section) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: "".concat(formStore.name, "-").concat(section.id)
        }, _this3.renderSection(section));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formStore = _this$props.formStore,
          onSubmit = _this$props.onSubmit,
          onError = _this$props.onError,
          buttons = _this$props.buttons,
          errorSummaryEnabled = _this$props.errorSummaryEnabled,
          noTick = _this$props.noTick,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: formStore,
        onSubmit: onSubmit,
        onError: onError,
        noTick: noTick
      }, this.renderFields(), children, errorSummaryEnabled && /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: formStore
      }), buttons && /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, typeof buttons === 'function' ? buttons(this.handleFormSubmitted) : buttons));
    }
  }]);

  return FormBuilder;
}(_react.default.Component);

_defineProperty(FormBuilder, "defaultProps", {
  onSubmit: function onSubmit() {},
  onError: function onError() {},
  errorSummaryEnabled: true,
  buttons: null,
  adapters: null,
  noTick: false,
  children: null
});

_defineProperty(FormBuilder, "propTypes", {
  formStore: _propTypes.default.object.isRequired,
  onSubmit: _propTypes.default.func,
  onError: _propTypes.default.func,
  errorSummaryEnabled: _propTypes.default.bool,
  buttons: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  adapters: _propTypes.default.object,
  children: _propTypes.default.node,
  noTick: _propTypes.default.bool
});

var _default = (0, _mobxReact.observer)(FormBuilder);

exports.default = _default;
//# sourceMappingURL=FormBuilder.js.map